// The little Markdown Artemis writes in a skill's rewrite (OptimizedBody, OptimizedAppliesWhen; API-3801):
// headings, bulleted and numbered lists, paragraphs, **bold** and `code` spans naming tools. Parsed to plain
// data so it renders as React elements, read only; anything else stays as text.

// → [{ type: 'heading', text } | { type: 'list', ordered, items: [text] } | { type: 'para', text }]
export const markdownBlocks = source => {
  const blocks = []
  let para = []
  const endPara = () => { if (para.length) { blocks.push({ type: 'para', text: para.join(' ') }); para = [] } }
  String(source || '').replace(/\r\n?/g, '\n').split('\n').forEach(raw => {
    const line = raw.trim()
    if (!line) return endPara()
    const heading = /^#{1,6}\s+(.*)$/.exec(line)
    if (heading) { endPara(); blocks.push({ type: 'heading', text: heading[1].replace(/\s*#+\s*$/, '') }); return }
    const bullet = /^[-*+]\s+(.*)$/.exec(line)
    const numbered = /^\d+[.)]\s+(.*)$/.exec(line)
    if (bullet || numbered) {
      endPara()
      const ordered = !!numbered
      const last = blocks[blocks.length - 1]
      if (last && last.type === 'list' && last.ordered === ordered) last.items.push((numbered || bullet)[1])
      else blocks.push({ type: 'list', ordered, items: [(numbered || bullet)[1]] })
      return
    }
    // A wrapped line carries on the list item before it.
    const last = blocks[blocks.length - 1]
    if (!para.length && last && last.type === 'list' && /^\s{2,}\S/.test(raw)) { last.items[last.items.length - 1] += ` ${line}`; return }
    para.push(line)
  })
  endPara()
  return blocks
}

// A line's `code` and **bold** spans: [{ text, code?, bold? }].
export const markdownInline = text => {
  const parts = []
  const re = /`([^`]+)`|\*\*([^*]+)\*\*/g
  let at = 0, m
  const s = String(text || '')
  while ((m = re.exec(s))) {
    if (m.index > at) parts.push({ text: s.slice(at, m.index) })
    parts.push(m[1] != null ? { text: m[1], code: true } : { text: m[2], bold: true })
    at = re.lastIndex
  }
  if (at < s.length) parts.push({ text: s.slice(at) })
  return parts
}
